import React, { useEffect, useState } from "react";

// Animated circular risk gauge (0-100). Color from status.
export const RiskGauge = ({ score, color, size = 132, label }) => {
  const [display, setDisplay] = useState(0);
  const radius = (size - 14) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = score == null ? 0 : Math.max(0, Math.min(100, score));

  useEffect(() => {
    let raf;
    const start = performance.now();
    const duration = 900;
    const animate = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * pct));
      if (p < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [pct]);

  const offset = circumference - (display / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="check-risk-gauge" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E2E8F0" strokeWidth="9" />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth="9"
          strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.1s linear", filter: `drop-shadow(0 0 6px ${color}66)` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {score == null ? (
          <span className="text-3xl font-bold text-slate-500">—</span>
        ) : (
          <span className="font-mono text-3xl font-bold" style={{ color }}>{display}</span>
        )}
        {label && <span className="mt-0.5 text-[10px] uppercase tracking-widest text-slate-500">{label}</span>}
      </div>
    </div>
  );
};
